<template>
 <div :class="['c-plan-card js-slider-item gtm-section-offer', isPlanSelectedFromUrl ? 'is-selected' : '']" @click="this.slideParent">
    <span v-if="data.custom_label && data.custom_label.length > 0" class="c-plan-card__label t-label t-label--yellow">{{ data.custom_label }}</span>

    <div class="c-plan-card__top">
        <div class="u-marg-b-xxs">
            <p class="t-h2">{{ data.name }}</p>
            <p v-if="subtitle" class="t-h2 u-orange2">{{ subtitle }}</p>
        </div>
        <div class="c-pricing u-marg-b-xs">
            <div v-if="data.monthly_promo_price && data.monthly_promo_price.length > 0 && dateTimeForPlansPromo"
                   class="c-pricing__price u-inline-block">{{ data.monthly_promo_price_formatted.replace(/\s/g, '') }}</div>
            <div v-else class="c-pricing__price u-inline-block">{{ data.monthly_price_formatted.replace(/\s/g, '') }}</div>
            <div v-if="data.plan_promo_price_text && data.plan_promo_price_text.length > 0 && dateTimeForPlansPromo"
                 class="c-pricing__muted-text u-inline-block u-marg-l-xxxs u-marg-l-xxxs--xs"
                 v-html="$t('Monthly plan') + ' ' + data.plan_promo_price_text + ' ' + data.monthly_price_formatted.replace(/\s/g, '') + $t('Monthly plan')">
            </div>
            <div v-else class="c-pricing__muted-text u-inline-block u-marg-l-xxxs">{{ $t('Monthly plan') }}</div>
            <div class="c-pricing__muted-text" style="margin-left: 2px" v-html="isSoloPhone"></div>
        </div>

        <ul
          v-if="displayedCategoryCharacteristics && displayedCategoryCharacteristics.length > 0"
          class="t-text t-text--small">
            <li
              v-for="(charac, index) in displayedCategoryCharacteristics"
              :key="charac.information + '-' + index"
              class="c-plan-card__bullet-point u-marg-b-xxxs">
                <em
                  class="c-plan-card__bullet-icon t-icon t-icon--sm t-icon--bg"
                  :style="`background-image: url(${charac.picto});`"></em>
                <span>{{ charac.information }}</span>
            </li>
        </ul>

        <p
          v-if="data.characteristics && data.characteristics.length > 4"
          class="c-plan-card__know-more u-bold u-marg-t-xxs u-inline-block u-cursor-pointer"
          data-toggle="modal"
          data-target="#planModal">
            <span>{{ $t('More details') }}</span>
            <span class="t-info"></span>
        </p>

    </div>

    <div class="c-plan-card__bottom">
        <p class="c-plan-card__bottom__title u-bold u-antialiased">{{ $t('Phone') }}</p>
        <div class="c-pricing u-marg-t-xxxs">
            <div v-if="(this.data.base_price !== this.data.final_price) || (this.productInformations.prices[this.currentProduct.sku].price < this.productInformations.instalments[this.currentProduct.sku].items[0].base_price)"
                 class="c-pricing__muted-text u-bold u-line-through">
              <p v-if="this.currentProduct.plan.option_value === this.data.option_value" v-html="oldMobilePrice"></p>
                <div v-else class="u-pad-xxxs"></div>
            </div>
            <div class="c-pricing__price u-inline-block u-antialiased">{{ mobilePrice }}</div>
            <div
              v-if="data.instalment_amount"
              v-html="pricing(data.instalment_amount, data.instalment_duration)"
              class="c-pricing__muted-text u-inline-block u-marg-l-xxxs">
            </div>
        </div>
    </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { CalculateMobilePrice } from './Mixins/CustomOptionsMixins'

  export default {
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      slide: {
        type: Function,
        default: () => {},
      },
      index: {
        type: Number,
        default: 0,
      },
      isPlanSelectedFromUrl: {
        type: Boolean,
        default: () => false
      }
    },
    computed: {
      ...mapGetters({
        currentProduct: 'GET_CURRENT_PRODUCT',
        productInformations: 'GET_PRODUCT_INFORMATIONS',
        $t: 'GET_TRAD'
      }),
      mobilePrice () {
        let optionPrice =  parseFloat(this.data.price) + parseFloat(this.productInformations.prices[this.currentProduct.sku].price);
        return CalculateMobilePrice({optionPrice: optionPrice, currency: this.currentProduct.currency, locale: this.productInformations.locale})
      },
      isSoloPhone () {
          if (this.data.monthly_price === 0) {
              // solo phone
              return this.$t('without engagement')
          } else if (this.currentProduct.plan.device_plan_engagement_duration == 0 && this.currentProduct.plan.instalment_duration == 0 && this.currentProduct.plan.instalment_amount == 0) {
              // No commitment plan
              return this.$t('No commitment')
          } else {
          // classic plan
            return this.$t('24 month commitment')
        }
      },
        displayedCategoryCharacteristics() {
            const characteristics = [...this.data.characteristics];

            if (characteristics && characteristics.length > 0) {
                // Filter characteristics to include only those of type 'category'
                const categoryCharacteristics = characteristics.filter(charac => charac.type === 'category');

                // Limit the displayed characteristics to a maximum of 4
                if (categoryCharacteristics.length > 4) {
                    return categoryCharacteristics.slice(0, 4);
                } else {
                    return categoryCharacteristics;
                }
            }
        },
      subtitle: function () {
        if (this.data.subtitle.length !== 0) {
          return this.data.subtitle
        } else {
          return ''
        }
      },
      oldMobilePrice () {
          let optionPrice
          if (this.data.sku === '') {
              optionPrice = parseFloat(this.data.price) + parseFloat(this.productInformations.instalments[this.currentProduct.sku].items[0].base_price);
          } else {
              optionPrice = parseFloat(this.data.base_price);
          }
            return CalculateMobilePrice({
                optionPrice: optionPrice,
                currency: this.currentProduct.currency,
                locale: this.productInformations.locale
            });
        },
        dateTimeForPlansPromo() {
            let startDate
            let endDate
            if (this.data.promo_date_start_1 || this.data.promo_date_end_1) {
                startDate = this.data.promo_date_start_1;
                endDate = this.data.promo_date_end_1;
            } else {
                return false;
            }

            let timezone = this.data.timezone_config;
            var now = new Date();
            var currentTime = now.toLocaleString('sv-SE', {timeZone: timezone});

            return startDate <= currentTime && endDate >= currentTime
        }
    },
    methods: {
      pricing (instalment_amount, instalment_duration) {
          if (this.currentProduct.plan.device_plan_engagement_duration == 0 && this.currentProduct.plan.instalment_duration == 0 && this.currentProduct.plan.instalment_amount == 0) {
              return this.$t('at checkout,</br>no monthly fee')
          } else
        if (this.productInformations.locale === 'en') {
          return this.$t('%1/month</br>for %2 month').replace('%1', `${this.currentProduct.currency}${instalment_amount}`).replace('%2', instalment_duration)
        } else {
          return this.$t('%1/month</br>for %2 month').replace('%1', `${instalment_amount}${this.currentProduct.currency}`).replace('%2', instalment_duration)
        }
      },

      slideParent() {
        this.$emit('slide', this.index);
      }
    }
  }
</script>
